import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import '../css/getListaItems.css';
import 'whatwg-fetch';
import GetCombo from './getCombo';
class getListaItems extends Component {
  constructor(props){
    super(props);
    this.state = {
      sub_modulo_modal : '',
      id_rubro : 0,
      id_producto_combo:0,
      id_index:-1,
      precio_combo:0,
      sw_iva:0,
      uuid_image_2:'',
      item_tmp:'',
      windowWidth: window.innerWidth
    }
  }
  get_opcion_no =()=>{

  }
  get_opcion_si =()=>{
    this.get_go_to("")
  }
  get_to_go_salir =()=>{
    const total_items = this.props.total_items
    if(total_items>0){
      confirmAlert({
        title: 'Cancelar Pedido',
        message: '¿Desea cancelar Pedido?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.get_opcion_si()
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }else{
      this.get_go_to("")
    }
  }
  get_go_to =(modulo_modal)=>{
    this.props.get_go_to(modulo_modal)
  }
  consultarItemAPI =()=>{
    const id_sucursal =this.props.id_sucursal
    const sucursal =this.props.sucursal
    const id_mesa =this.props.id_mesa
    const url= this.props.dir_url + "webapp/getItems";
    const token =  this.props.token

    var obj = { accion:'listaItems', token,id_sucursal,id_mesa,sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.props.props_set_data_items(data)
      }
      //console.log(data)
    })
    .catch(console.log)
    //this.get_loading(true)

  }
 salir_prefencias =()=>{
   this.setState({
     id_producto_combo:0,
     sub_modulo_modal:'',
     id_index:-1,
     precio_combo:0,
     sw_iva:0
   })
 }
 agregarPreferencias =(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)=>{
   this.setState({
     id_producto_combo:0,
     sub_modulo_modal:'',
     id_index:-1,
     precio_combo:0,
     sw_iva:0
   },()=>{
     this.props.props_set_preferencias(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)
   })
 }
 salir_get_vista_previa =()=>{
   this.setState({
     sub_modulo_modal:'',
     uuid_image_2:'',
     item_tmp:''
   })
 }
 get_vista_previa =(uuid_image_2,item_tmp)=>{
   //console.log(uuid_image_2)
   if(uuid_image_2){
     if(uuid_image_2.trim()!==''){
       this.setState({
         sub_modulo_modal:'vistaprevia',
         uuid_image_2,
         item_tmp
       })
     }
   }
 }
 agregarCantidad = (index,combo,precio_combo,sw_iva,title) => {

  if(Number(combo)===1){
    this.setState({
      title,
      id_producto_combo:index,
      sub_modulo_modal:'combo',
      id_index:-1,
      precio_combo,
      sw_iva
    })
  }else{
    var items_cantidad = this.props.items_cantidad.slice();
    if(isNaN(items_cantidad[index])){
      items_cantidad[index] = 1;
    }else{
      items_cantidad[index] = Number(items_cantidad[index]) + 1;
    }
    this.props.props_set_cantidad(items_cantidad)
  }
}
inputChangedHandlerText1 =(event,index)=>{
  var items_observaciones = this.props.items_observaciones.slice();
  items_observaciones[index] = event.target.value;
  this.props.props_set_observacion(items_observaciones)
}
KinputChangedHandlerText1=(event)=>{
    if (event.keyCode === 13) {
       //console.log("Enter key pressed!!!!!");
       document.getElementById('button_continuar').focus();
    }
}
eliminarCantidad = (index) => {
  var items_cantidad = this.props.items_cantidad.slice();
  if(isNaN(items_cantidad[index])){
    items_cantidad[index] = "";
  }else{
    items_cantidad[index] = Number(items_cantidad[index]) - 1;
    if(items_cantidad[index]<=0){
      items_cantidad[index] = "";
    }
  }
  this.props.props_set_cantidad(items_cantidad)
}
  get_to_go_salir_rubro =()=>{
    this.setState({
      id_rubro:0
    })
  }
  setExpandirRubro =(id_rubro)=>{
    if(Number(this.props.id_mesa)===-1){
      return null
    }
    this.setState({
      id_rubro
    })
  }
  editarPreferencia =(id_producto_combo,index,precio_combo,sw_iva,title)=>{
    this.setState({
      title,
      id_producto_combo:id_producto_combo,
      sub_modulo_modal:'combo',
      id_index:index,
      precio_combo,
      sw_iva
    })
  }
  eliminarPreferencia =(index)=>{
    this.props.props_set_delete_preferencias(index)
  }
  getDescripcionPreferencia=(ditem)=>{
    let descripcion = ''
    ditem.complemento_final.forEach(cp_detalle => {
        if(cp_detalle.complemento==='Combo'){
          cp_detalle.CDetalle.forEach(cp_detalle_combo => {
             if(descripcion!=='') descripcion = descripcion + ' + '
             descripcion = descripcion + cp_detalle_combo.cant + 'x '+ cp_detalle_combo.producto
          })
        }else{
          if(descripcion!=='') descripcion = descripcion + ' + '
          if(cp_detalle.complemento==='Adicional'){
            descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$'
          }else{
            descripcion = descripcion +  cp_detalle.producto
          }
        }
    })
    return(
      <React.Fragment>
        {descripcion}
      </React.Fragment>
    )
  }
  getDetallePreferencia=(index,precio_venta,component,descripcion,token_image,uuid_imagen,ext,sw_iva)=>{
    //console.log("final")
    //console.log(this.props.lista_items_adicional)
    const lista_items_adicional = this.props.lista_items_adicional.filter(
      lista_items_adicional => Number(lista_items_adicional.id_producto_combo) === Number(index)
    )
    //console.log("final2")
    //console.log(lista_items_adicional)
    return (
      <React.Fragment>
      {lista_items_adicional.map((ditem , index) => (
        <div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} >
          <div className="cssversion_pw10 cssversion_pxh90">
            <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
              1x
            </div>
            <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarPreferencia(index)} >
              <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
            </div>
          </div>
          <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
            <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
             src={
               ((uuid_imagen+'').trim()==='')?
                 "https://www.grupomn.net/app/img/sinfoto.png"
               :
                 token_image+uuid_imagen+ext
               }/>
          </div>
          <div className="cssversion_pw55 cssversion_pxh90">
            <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
              <span className="span-global-title-producto">{component}</span>
            </div>
            <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
              <span className="span-global-title-descripcion">
              {
                this.getDescripcionPreferencia(ditem)
              }
              </span>
            </div>
          </div>
          <div className="cssversion_pw15 cssversion_pxh90">
            <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
              <span className="span-global-title-cantidad">${(Number(ditem.precio_adicional)+Number(precio_venta)).toFixed(2)}</span>
            </div>
            <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva,component)}>
            <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
            </div>
          </div>
        </div>
      ))}
      </React.Fragment>
    )
    /**/




    /*<div className="grid-container-items" key={index} >
      <div className="lbl_cantidad-items">
      1x</div>
      <div className="lbl_restar-items" >
      <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarPreferencia(index)}
      className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
      </div>
      <div className="lbl_precio-items">${Number(ditem.precio_adicional)+Number(precio_venta)}</div>
      <div className="lbl_sumar-items">
      <img style={{"width":"20px","height":"20px"}} onClick={ () => this.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva)}
      className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
      </div>
      <div className="lbl_item-items">{component}</div>
      <div className="lbl_descripcion-items">{descripcion}</div>
      <div className="lbl-imagen-items">
        <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
         src={
           ((uuid_imagen+'').trim()==='')?
             "https://www.grupomn.net/app/img/sinfoto.png"
           :
             token_image+uuid_imagen+ext
           }/>
      </div>
    </div>*/
  }


  mostrarItems = () => {

    console.log(this.state.windowWidth)
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    const file_xxx250x200 =this.props.file_250x200
    const file_xxx250x250 =this.props.file_250x250
    const token_image = url_image+file_xxx+separator
    const token_image_rubro = url_image+file_xxx250x200+separator
    const token_imageI = url_image+file_xxx250x250+separator
    const ext="_60x60.png?alt=media"
    const ext250x200="_250x200.png?alt=media"
    const ext250x250="_250x250.png?alt=media"

     const items = this.props.lista_items

     if(items.length === 0) return null
     const id_rubro = this.state.id_rubro
     /*<div className="grid grid-bleed pw100 pxh140">
     </div>*/
     /*<div className="grid-container-items-rubros-expandido" onClick={ () => this.setExpandirRubro(item.Cidrubro)}>
       <div className="lbl_title-items-rubros-expandido">{item.Crubro}</div>
       <div className="lbl_image-items-rubros-expandido">
       <img style={{"width":"100px","height":"80px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
        src={
          ((item.Cuuidimagenrubro+'').trim()==='')?
            "https://www.grupomn.net/app/img/sinfoto.png"
          :
            token_image_rubro+item.Cuuidimagenrubro+ext250x200
          }/></div>
     </div>*/



     /*<div className="grid-container-items" >
       <div className="lbl_cantidad-items">
       {(this.props.items_cantidad[ditem.id])?this.props.items_cantidad[ditem.id]+"x":""}</div>
       <div className="lbl_restar-items" >
       {(this.props.items_cantidad[ditem.id])?
       <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(ditem.id)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
       :''}
       </div>
       <div className="lbl_precio-items">${ditem.precio_venta}</div>
       <div className="lbl_sumar-items" onClick={ () => this.agregarCantidad(ditem.id,ditem.combo,ditem.precio_venta,ditem.sw_iva) }><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  /></div>
       <div className="lbl_item-items">{ditem.component}</div>
       <div className="lbl_descripcion-items">{ditem.descripcion}</div>
       <div className="lbl-imagen-items">
         <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
          src={
            ((ditem.uuid_imagen+'').trim()==='')?
              "https://www.grupomn.net/app/img/sinfoto.png"
            :
              token_image+ditem.uuid_imagen+ext
            }/>
       </div>
     </div>*/




     /*<div  className="grid grid-bleed pw100 pxh80 borderBottom" style={{"margin":"0px"}} onClick={ () => this.setExpandirRubro(item.Cidrubro)}>
       <div className="col-6 col-grid centerContent pxh80">
         <span className="span-global-link">{item.Crubro}</span>
       </div>
       <div className="col-6 col-grid centerContent pxh80">
         <img style={{"borderRadius": "20%"}} className="pxh70 pxw100" alt="Cargando Imagen . . ."
          src={
            ((item.Cuuidimagenrubro+'').trim()==='')?
              "https://www.grupomn.net/app/img/sinfoto.png"
            :
              token_image_rubro+item.Cuuidimagenrubro+ext250x200
            }/>
       </div>
     </div>*/
     //console.log(items)
     return (
       <React.Fragment>
         {items.map((item , index) => (
           <React.Fragment key={index}>
              {(Number(id_rubro)===0)?
                <React.Fragment>  
                  {(Number(this.state.windowWidth)<=500)?
                    <React.Fragment>
                      <div className="cssversion_pw100 cssversion_pxh80 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} onClick={ () => this.setExpandirRubro(item.Cidrubro)}>
                        <div className="cssversion_pw50 cssversion_pxh80 cssversion_contentCenter">
                          <span className="span-global-link">{item.Crubro}</span>
                        </div>
                        <div className="cssversion_pw50 cssversion_pxh80 cssversion_contentCenter">
                          <img style={{"borderRadius": "20%"}} className="pxh70 pxw100" alt="Cargando Imagen . . ."
                          src={
                            ((item.Cuuidimagenrubro+'').trim()==='')?
                              "https://www.grupomn.net/app/img/sinfoto.png"
                            :
                              token_image_rubro+item.Cuuidimagenrubro+ext250x200
                            }/>
                        </div>
                      </div>
                    </React.Fragment>
                  :
                  <React.Fragment>
                    <div className="cssversion_pxw250 cssversion_pxh400 borderBottom div_rubros" style={{"display":"inline-flex","borderRadius": "25px 0px 25px 0px","padding": "5px"}} onClick={ () => this.setExpandirRubro(item.Cidrubro)}>
                      <div className="cssversion_pw100 cssversion_ph100 cssversion_contentCenter" style={{"backgroundImage": `url(${((item.Cuuidimagenrubro+'').trim()==='')?
                              "https://www.grupomn.net/app/img/sinfoto.png"
                            :
                              token_image_rubro+item.Cuuidimagenrubro+ext250x200})`,"backgroundSize": "cover","backgroundPosition": "center"}}>
                        <div className="cssversion_pw100 cssversion_pxh80 cssversion_contentCenter" style={{"backgroundColor":"rgba(255, 255, 255, 0.2)"}}>
                          <span className="span-global-link">{item.Crubro}</span>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }    
                </React.Fragment>
                :
                <React.Fragment>
                {(Number(id_rubro)===Number(item.Cidrubro))?
                  <div className="cssversion_pw100 cssversion_pxh30 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} onClick={ () => this.get_to_go_salir_rubro()}>
                    <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter">
                      <span className="span-global-link">{item.Crubro}</span>
                    </div>
                  </div>
                :''}
                </React.Fragment>
              }

              {item.Citems.map((ditem , dindex) => (
                <React.Fragment key={"key_item_"+ditem.id}>
                {(Number(this.props.id_mesa)!==-1&&Number(id_rubro)===0&&(!this.props.items_cantidad[ditem.id]))?
                  '':
                <React.Fragment>
                {(Number(this.props.id_mesa)===-1||Number(id_rubro)===Number(item.Cidrubro)||this.props.items_cantidad[ditem.id])?
                  <React.Fragment>



                    <div className={(Number(this.state.windowWidth)<=500)?"cssversion_pw100 cssversion_pxh110 borderBottom":"borderBottom div_rubros cssversion_pxw300 cssversion_pxh90 cssversion_flexline"} style={{"borderRadius": "25px 0px 25px 0px"}} >
                      <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
                        <div className="cssversion_pw10 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            {(this.props.items_cantidad[ditem.id])?
                              <span className="span-global-title-cantidad">
                                {this.props.items_cantidad[ditem.id]+"x"}
                              </span>
                              :
                              ""
                            }
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarCantidad(ditem.id)} >
                            {(this.props.items_cantidad[ditem.id])?
                            <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
                            :''}
                          </div>
                        </div>
                        <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <img onClick={ () => this.get_vista_previa(ditem.uuid_imagen_2,ditem.component)}  style={{"width":"70px","height":"70px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                           src={
                           ((ditem.uuid_imagen+'').trim()==='')?(
                             "https://www.grupomn.net/app/img/sinfoto.png")
                           :(
                             ((ditem.uuid_imagen_2+'').trim()!=='')?
                             token_imageI+ditem.uuid_imagen_2+ext250x250
                             :
                             token_image+ditem.uuid_imagen+ext
                           )
                           }/>
                        </div>
                        <div className="cssversion_pw55 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-producto">{ditem.component}</span>
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-descripcion">{ditem.descripcion}</span>
                          </div>
                        </div>
                        <div className="cssversion_pw15 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-cantidad">${ditem.precio_venta}</span>
                          </div>
                          {(Number(this.props.id_mesa)===-1)?
                            <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                            </div>
                              :
                            <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.agregarCantidad(ditem.id,ditem.combo,ditem.precio_venta,ditem.sw_iva,ditem.component) } >
                              <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  />
                            </div>
                          }
                        </div>
                      </div>
                      {(this.props.items_cantidad[ditem.id])?
                      <div className="cssversion_pw100">
                      <input onKeyUp={(event)=>this.KinputChangedHandlerText1(event)} value={(this.props.items_observaciones[ditem.id])?this.props.items_observaciones[ditem.id]:''} onChange={(event)=>this.inputChangedHandlerText1(event,ditem.id)} className="input-global-v2 cssversion_pw90" placeholder="Añadir una nota (más salsa, sin cebolla, etc.)" />
                      </div>
                      :''}
                    </div>

                  </React.Fragment>
                :''}
                </React.Fragment>
                }
                {
                  this.getDetallePreferencia(ditem.id,ditem.precio_venta,ditem.component,ditem.descripcion,
                    token_image,ditem.uuid_imagen,ext,ditem.sw_iva)
                }
                </React.Fragment>
              ))}
           </React.Fragment>
         ) ) }
       </React.Fragment>
     )
   }
/*
<div  className="grid grid-bleed pw100 pxh80 borderBottom" style={{"margin":"0px"}}>
  <div className="col-1 col-grid centerContent pxh80">
    <div  className="grid grid-bleed pw100 pxh40 borderBottom" style={{"margin":"0px"}}>
      <div className="col-12 col-grid centerContent pxh40">
        {(this.props.items_cantidad[ditem.id])?
          <span className="span-global-title-cantidad">
            {this.props.items_cantidad[ditem.id]+"x"}
          </span>
          :
          ""
        }
      </div>
      <div className="col-12 col-grid centerContent pxh40">
        {(this.props.items_cantidad[ditem.id])?
        <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(ditem.id)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
        :''}
      </div>
    </div>
  </div>
  <div className="col-2 col-grid centerContent pxh80">
    <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
     src={
     ((ditem.uuid_imagen+'').trim()==='')?
       "https://www.grupomn.net/app/img/sinfoto.png"
     :
       token_image+ditem.uuid_imagen+ext
     }/>
  </div>
  <div className="col-7 col-grid centerContent pxh80">
    <div  className="grid grid-bleed pw100 pxh40 borderBottom" style={{"margin":"0px"}}>
      <div className="col-12 col-grid centerContent pxh40">
        <span className="span-global-title-producto">{ditem.component}</span>
      </div>
      <div className="col-12 col-grid centerContent pxh40">
         <span className="span-global-title-descripcion">{ditem.descripcion}</span>
      </div>
    </div>
  </div>
  <div className="col-2 col-grid centerContent pxh80">
    <div  className="grid grid-bleed pw100 pxh40 borderBottom" style={{"margin":"0px"}}>
      <div className="col-12 col-grid centerContent pxh40">
        <span className="span-global-title-cantidad">${ditem.precio_venta}</span>
      </div>
      <div className="col-12 col-grid centerContent pxh40"  onClick={ () => this.agregarCantidad(ditem.id,ditem.combo,ditem.precio_venta,ditem.sw_iva) }>
        <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  />
      </div>
    </div>
  </div>
</div>
*/
  render() {
    //let logo
    /*const uuid_imagen=((this.props.uuid_sucursal)+"").trim()
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_500x200
    const token_image = url_image+file_xxx+separator
    const ext="_500x200.png?alt=media"
    /*if(uuid_imagen===''){
      logo="https://www.grupomn.net/app/img/sinfoto.png"
    }else{
      logo=token_image+uuid_imagen+ext
    }*/
    const total_items = this.props.total_items
    const total_precio = this.props.total_precio
    const id_rubro = this.state.id_rubro

    const sub_modulo_modal = this.state.sub_modulo_modal
    let dir_sub_modulo_modal

    if(sub_modulo_modal==='combo'){
      dir_sub_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
        <GetCombo sw_iva={this.state.sw_iva} precio_combo={this.state.precio_combo} lista_items_adicional={this.props.lista_items_adicional} id_index={this.state.id_index} agregarPreferencias={this.agregarPreferencias} salir_prefencias={this.salir_prefencias} id_producto_combo={this.state.id_producto_combo} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}   props_set_data_items={this.props_set_data_items} props_set_cantidad={this.props_set_cantidad} lista_items={this.state.lista_items}  items_cantidad={this.state.items_cantidad} total_items={this.state.total_items} total_precio={this.state.total_precio} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} id_sucursal={this.state.id_sucursal} title={this.state.title} costo_delivery={this.state.costo_delivery} puntuacion={this.state.puntuacion} tiempo={this.state.tiempo} />
        </div>
    }
    if(sub_modulo_modal==='vistaprevia'){
      const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
      const separator = this.props.separator//"/o/images%2F"
      //const file_xxx =this.props.file_60x60
      const file_xxx250x250 =this.props.file_250x250
      //const token_image = url_image+file_xxx+separator
      const token_image_rubro = url_image+file_xxx250x250+separator
      //const ext="_60x60.png?alt=media"
      const ext250x250="_250x250.png?alt=media"

      dir_sub_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active cssversion_contentCenter" data-text="">
       <div className="cssversion_menu cssversion_colorblanco"  style={{"width":"350px","height":"350px"}} >
           <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.salir_get_vista_previa()}>
             <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }  />
             </div>
             <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
               <span className="span-global-link" >{this.state.item_tmp}</span>
             </div>
           </div>
           <div className="cssversion_pw100 cssversion_pxh250 cssversion_contentCenter" style={{"display":"flex"}} >
            <img style={{"borderRadius": "20%"}} className="pxh250 pxw250" alt="Cargando Imagen . . ." src={token_image_rubro+this.state.uuid_image_2+ext250x250}/>
           </div>
       </div>
      </div>
    }
    
    return (
      <div className="cssversion_menu cssversion_colorprimario">
        <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco cssversion_contentCenter" >
          <span className="cssversion_span-title-sucursal">{this.props.title}</span>
        </div>
        {(Number(this.props.id_mesa)===-1)?
          <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
            <div className="cssversion_pw100 cssversion_ph100 cssversion_colorblanco" style={{"overflowY":"auto"}}>
              {this.mostrarItems()}
            </div>
          </div>
          :
          <React.Fragment>
          <div className="cssversion_pw100 cssversion_ph75" style={{"display":"flex"}}>
            <div className="cssversion_pw100 cssversion_ph100 cssversion_colorblanco" style={{"overflowY":"auto"}}>
              {this.mostrarItems()}
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_ph15 cssversion_colorblanco cssversion_contentCenter" style={{"display":"flex"}}>
            {(Number(id_rubro)===0)?
              <React.Fragment>
                {(Number(this.props.id_mesa)===0)?
                  <button  style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global"  onClick={ () => this.get_to_go_salir()}>Regresar</button>
                :''}
              </React.Fragment>
            :
            <button style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global"  onClick={ () => this.get_to_go_salir_rubro()}>Regresar</button>
            }
            {(Number(total_items)>0)?
            <button id="button_continuar" style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global" onClick={ () => this.get_go_to("finalizar_pedido")}>Pedir {total_items} por ${Number(total_precio).toFixed(2)}</button>
            :
            <button id="button_continuar" style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global-disabled" ></button>}
          </div>
          </React.Fragment>
        }
        {dir_sub_modulo_modal}
      </div>
    )
  }
///  <div className="cssversion_pw100 cssversion_ph15 cssversion_contentCenter">
//  <button style={{"width":"48%"}} className="button-global" onClick={ () => this.get_to_go_salir()}>Regresar</button>

/*<div className="grid colorblanco grid-bleed ph100 pw100" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
  <div className="col-12 col-grid">
    <div className="grid grid-bleed ph100 pw100" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
      <div className="col-12 col-grid ph75 yoverflow" style={{"position": "fixed"}}>
        <div className="grid grid-bleed ph100 pw100" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
          <div className="col-12 col-grid">

            <div className="grid grid-bleed pw100 pxh140"
              style={{
                "backgroundImage": "url(" + logo + ")","margin":"7px 0px 7px 0px",
                "borderRadius": "25px","display": "inline-table","letterSpacing":"0em","wordSpacing":"0em"
              }}
              >
              <div className="col-12 col-grid pxh100 centerContent">
                <span className="span-title-sucursal">{this.props.title}</span>
              </div>
              <div className="col-2 pxh40 colorblanco">
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/11140696671582004489-128.png') }  />
                <span className="span-global">{this.props.costo_delivery}$</span>
              </div>
              <div className="col-8 pxh40 colorblanco">
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
                <span className="span-global">{this.props.kilometro+"Km"}</span>
              </div>
              <div className="col-2 pxh40 colorblanco">
                <span className="span-global">{this.props.tiempo}'</span>
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16882276531582004488-128.png') }  />
              </div>
            </div>
            {this.mostrarItems()}
          </div>
        </div>
      </div>
      <div className="col-12 col-grid centerContent ph25 footer-global" style={{"position": "fixed"}}>
        {(Number(total_items)>0)?
        <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_go_to("finalizar_pedido")}>Pedir {total_items} por ${Number(total_precio).toFixed(2)}</button>
        :''}
        {(Number(id_rubro)===0)?
        <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_to_go_salir()}>Regresar</button>
        :
        <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_to_go_salir_rubro()}>Regresar</button>
        }
      </div>
    </div>
  </div>
  {dir_sub_modulo_modal}
</div>*/


















  /*<React.Fragment>
  <div className="grid-container-global_items">
    <div className="container-items-global" >
      <div className="grid-container-title-items" style={{"backgroundImage": "url(" + logo + ")"   }} >
        <div className="lbl_costo_delivery-title-items">
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/11140696671582004489-128.png') }  />
          {this.props.costo_delivery}$
        </div>
        <div className="lbl_puntuacion-title-items">
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4400210571582004493-128.png') }  />
          {this.props.puntuacion}%
        </div>
        <div className="lbl_tiempo-title-items">
          {this.props.tiempo}'
          <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16882276531582004488-128.png') }  />
        </div>
        <div className="lbl_local-title-items">
        {this.props.title}
        </div>
      </div>
      {this.mostrarItems()}
      <div className="grid-container-items-rubros" style={{"width":"100%","height":"130px"}} ></div>
    </div>
    <div className="container-items-buttons" >
    {(Number(total_items)>0)?
    <div className="float_button_step_buy">
      <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_go_to("finalizar_pedido")}>Pedir {total_items} por ${Number(total_precio).toFixed(2)}</button>
    </div>
    :''}

    <div className="float_button_step_cancelar">
      {(Number(id_rubro)===0)?
      <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_to_go_salir()}>Regresar</button>
      :
      <button style={{"width":"95%"}} className="button-global" onClick={ () => this.get_to_go_salir_rubro()}>Regresar</button>
      }
    </div>
    </div>
  </div>
  {dir_sub_modulo_modal}
  </React.Fragment>*/

  handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth,
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.consultarItemAPI()
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
}
export default getListaItems
